import { render } from "./ReservationCard.vue?vue&type=template&id=a95d9b4e&scoped=true&ts=true"
import script from "./ReservationCard.vue?vue&type=script&lang=ts"
export * from "./ReservationCard.vue?vue&type=script&lang=ts"

import "./ReservationCard.vue?vue&type=style&index=0&id=a95d9b4e&lang=scss&scoped=true"

import exportComponent from "D:\\Proyectos\\mytransfers-extranet-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a95d9b4e"]])

export default __exports__